<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <div v-if="msgAlerta" class="info-alert row-space">{{ msgAlerta }}</div>

    <div class="form-edit-page row">
        <div class="form-item">
            <div v-if="globalStore.showSelectEstabelecimento">
                <EstabelecimentoSelect v-model:idSelecionado="estabelecimentoSelecionado" />
            </div>
            <div v-else>
                <label class="label-caption">Estabelecimento</label>
                <div class="field-label">{{ globalStore.nmestabelecimento }}</div>
            </div>
        </div>
        
        <button type="button" class="buttom-icon--printer" @click="openReport" />
        <button type="button" class="buttom-icon--close" @click="closeForm" />
    </div>
</template>

<script setup>
import { ref } from 'vue';
import { genericReport } from '@/funcoes/api';
import { globalStore } from '@/globals';
import EstabelecimentoSelect from '../selects/EstabelecimentoSelect.vue';

const emit = defineEmits(['close']);
const estabelecimentoSelecionado = ref(null);
const isLoading = ref(false);
const msgAlerta=ref(null);

const closeForm = () => {emit('close');}

const openReport = async() => {
    try{
        msgAlerta.value=null;
        isLoading.value = true;
        const dados = {
            nmrelatorio: 'estabelecimentos_parecer',
            idep: globalStore.idep,
            idsim: globalStore.idsim,
            idestabelecimento: ((globalStore.ckperfilestabelecimento) || (globalStore.ckperfilrt)) ? globalStore.idestabelecimento : estabelecimentoSelecionado.value,
            idusuario: globalStore.idusuario
        };
        const response = await genericReport(dados);
        const pdfBlob = new Blob([response], { type: 'application/pdf' });
        const pdfUrl = URL.createObjectURL(pdfBlob);
        window.open(pdfUrl, '_blank');
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {isLoading.value = false;}
}
</script>